export default {
  'assets.selector.title': '选择参考{type}',
  'assets.selector.type.image': '图',
  'assets.selector.type.video': '视频',
  'assets.selector.localUpload': '从本地上传',
  'assets.selector.tab.upload': '上传资产',
  'assets.selector.tab.ai': 'AI生成',
  'assets.selector.loading': '加载中...',
  'assets.selector.deleteConfirm.title': '确认删除？',
  'assets.selector.deleteConfirm.content': '删除后不可恢复。',
  'assets.selector.deleteConfirm.ok': '删除',
  'assets.selector.deleteConfirm.cancel': '取消',
  'assets.selector.uploading': '上传中...',
  'assets.selector.uploadSuccess': '上传成功',
  'assets.selector.uploadFailed': '上传失败，请重试',
  'assets.selector.uploadNoWorkspace': '未找到工作空间，请先登录',
  'assets.selector.loadFailed': '资产列表加载失败',
  'assets.selector.deleteSuccess': '删除成功',
  'assets.selector.deleteFailed': '删除失败，请重试',
};

